import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import de from '../../messages/de.json';
import en from '../../messages/en.json';

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			de: { translation: de },
			en: { translation: en },
		},
		supportedLngs: ['de', 'en'],
		fallbackLng: 'en',
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['cookie', 'localStorage', 'navigator'],
		},
	});

i18n.on('languageChanged', () => {
	window.location.reload();
});

export default i18n;
